import { TWebsiteBuilderCSSVariable, WB_RICH_TEXT_FONT_SIZE_DESKTOP_CSS_VARIABLE, WB_RICH_TEXT_FONT_SIZE_TABLET_CSS_VARIABLE, WB_RICH_TEXT_FONT_SIZE_MOBILE_CSS_VARIABLE } from "../../website/shared/cssVariables";
import { Extension } from "@tiptap/core";
import { TWebsiteBuilderDevice } from "../../website/shared/device";

export type TWebsiteBuilderRichTextResponsiveFontSize = {
  [K in TWebsiteBuilderDevice]: string;
};

export function websiteBuilderNormalizeRichTextResponsiveFontSize(value: unknown): TWebsiteBuilderRichTextResponsiveFontSize {
  if (value == null || typeof value !== "object") {
    return {
      desktop: null,
      tablet: null,
      mobile: null,
    };
  }

  return {
    desktop: "desktop" in value && typeof value.desktop === "string" ? value.desktop : null,
    tablet: "tablet" in value && typeof value.tablet === "string" ? value.tablet : null,
    mobile: "mobile" in value && typeof value.mobile === "string" ? value.mobile : null,
  };
}

export function websiteBuilderGetRichTextResponsiveFontSizeStyles(
  responsiveFontSize: TWebsiteBuilderRichTextResponsiveFontSize,
): Record<TWebsiteBuilderCSSVariable, string> {
  return {
    [WB_RICH_TEXT_FONT_SIZE_DESKTOP_CSS_VARIABLE]: responsiveFontSize.desktop,
    [WB_RICH_TEXT_FONT_SIZE_TABLET_CSS_VARIABLE]: responsiveFontSize.tablet,
    [WB_RICH_TEXT_FONT_SIZE_MOBILE_CSS_VARIABLE]: responsiveFontSize.mobile,
  };
}

declare module "@tiptap/core" {
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-unused-vars
  interface Commands<ReturnType> {
    responsiveFontSize: {
      setResponsiveFontSize: (device: TWebsiteBuilderDevice, fontSize: string) => ReturnType;
      unsetResponsiveFontSize: (device: TWebsiteBuilderDevice) => ReturnType;
    };
  }
}

export const WebsiteBuilderRichTextResponsiveFontSize = Extension.create({
  name: "websiteBuilderRichTextResponsiveFontSize",

  addGlobalAttributes() {
    return [{
      types: ["doc"],
      attributes: {
        responsiveFontSize: {
          default: {
            desktop: null,
            tablet: null,
            mobile: null,
          },
          rendered: false,
        },
      },
    }];
  },

  addCommands() {
    return {
      setResponsiveFontSize: (device, fontSize) => ({ tr, dispatch }) => {
        if (dispatch) {
          const current = websiteBuilderNormalizeRichTextResponsiveFontSize(tr.doc.attrs.responsiveFontSize);

          const next: TWebsiteBuilderRichTextResponsiveFontSize = {
            ...current,
            [device]: fontSize,
          };

          tr.setDocAttribute("responsiveFontSize", next);
        }

        return true;
      },
      unsetResponsiveFontSize: device => ({ tr, dispatch }) => {
        if (dispatch) {
          const current = websiteBuilderNormalizeRichTextResponsiveFontSize(tr.doc.attrs.responsiveFontSize);

          const next: TWebsiteBuilderRichTextResponsiveFontSize = {
            ...current,
            [device]: null,
          };

          tr.setDocAttribute("responsiveFontSize", next);
        }

        return true;
      },
    };
  },
});
